<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-dialogbox">
            <div class='mcf-dialogbox-form'>
                <div class="mcf-dialogbox-header">
                    <label><i :class='setting.icon'></i> {{setting.title}}</label>
                    <input v-if="setting.extension!='image/*'" id="mcffile" type="file" :accept="'.'+setting.extension" @change="set_file">
                    <input v-if="setting.extension=='image/*'" id="mcffile" type="file" accept="image/*" @change="set_file">
                </div>
                <div class="mcf-dialogbox-buttons">
                    <ul>
                        <li @click="bt_explore">Parcourir</li>
                        <li @click="bt_cancel">Annuler</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props:{
        setting: Object
    },
    data(){
        return {
            
        };
    },
    created() {
        //document.getElementById('mcffile').click();
    },
    methods:{
        set_file: function(event){
            var tmain = this;
            var reader = new FileReader();
            var file = event.target.files[0];
            
            reader.readAsDataURL(file);
            reader.onload = function(){
                var sign_data = reader.result;
                var binary_str = window.atob(sign_data.replace("data:"+file.type+";base64,",""));
                var len = binary_str.length;
                var bytes = [];
                for (var i=0;i<len;i++){
                    bytes[i] = binary_str.charCodeAt(i);
                }
                var ret = {
                    filename: file.name,
                    data: bytes
                };
                tmain.setting.change(tmain.setting.id,ret,file);
            }
            reader.onerror = function(){
                tmain.setting.cancel();
            }
        },
        bt_explore: async function(){
            document.getElementById('mcffile').click();
        },
        bt_cancel: function(){
            this.setting.cancel();
        }

    }
}
</script>

<style>
</style>